import ApiService from './api';

/**
 * Exercise Service
 * Handles all exercise-related API requests
 */
const ExerciseService = {
  /**
   * Get all exercises
   * @param {string} token - Auth token
   * @param {Object} queryParams - Optional query parameters (filters)
   * @returns {Promise} - Response data
   */
  getAllExercises: async (token, queryParams = {}) => {
    const queryString = new URLSearchParams(queryParams).toString();
    const endpoint = `/api/exercises${queryString ? `?${queryString}` : ''}`;
    
    const response = await ApiService.get(endpoint, {
      'Authorization': `Bearer ${token}`
    });
    
    return response.json();
  },

  /**
   * Get a single exercise by ID
   * @param {string} exerciseId - Exercise ID
   * @param {string} token - Auth token
   * @returns {Promise} - Response data
   */
  getExerciseById: async (exerciseId, token) => {
    const response = await ApiService.get(`/api/exercises/${exerciseId}`, {
      'Authorization': `Bearer ${token}`
    });
    
    return response.json();
  },

  /**
   * Create a new exercise (admin only)
   * @param {Object} exerciseData - Exercise data
   * @param {string} token - Auth token
   * @returns {Promise} - Response data
   */
  createExercise: async (exerciseData, token) => {
    const response = await ApiService.post('/api/exercises', exerciseData, {
      'Authorization': `Bearer ${token}`
    });
    
    return response.json();
  },

  /**
   * Update an exercise (admin only)
   * @param {string} exerciseId - Exercise ID
   * @param {Object} exerciseData - Updated exercise data
   * @param {string} token - Auth token
   * @returns {Promise} - Response data
   */
  updateExercise: async (exerciseId, exerciseData, token) => {
    const response = await ApiService.put(`/api/exercises/${exerciseId}`, exerciseData, {
      'Authorization': `Bearer ${token}`
    });
    
    return response.json();
  },

  /**
   * Delete an exercise (admin only)
   * @param {string} exerciseId - Exercise ID
   * @param {string} token - Auth token
   * @returns {Promise} - Response data
   */
  deleteExercise: async (exerciseId, token) => {
    const response = await ApiService.delete(`/api/exercises/${exerciseId}`, {
      'Authorization': `Bearer ${token}`
    });
    
    return response.json();
  },
  
  /**
   * Get exercise categories
   * @param {string} token - Auth token
   * @returns {Promise} - Response data
   */
  getExerciseCategories: async (token) => {
    const response = await ApiService.get('/api/exercises/categories', {
      'Authorization': `Bearer ${token}`
    });
    
    return response.json();
  },
  
  /**
   * Get exercise difficulties
   * @param {string} token - Auth token
   * @returns {Promise} - Response data
   */
  getExerciseDifficulties: async (token) => {
    const response = await ApiService.get('/api/exercises/difficulties', {
      'Authorization': `Bearer ${token}`
    });
    
    return response.json();
  },
  
  /**
   * Get exercise muscles
   * @param {string} token - Auth token
   * @returns {Promise} - Response data
   */
  getExerciseMuscles: async (token) => {
    const response = await ApiService.get('/api/exercises/muscles', {
      'Authorization': `Bearer ${token}`
    });
    
    return response.json();
  }
};

export default ExerciseService;
